<template>
  <div>
    <div class="d-flex flex-row-reverse">
      <div class="col row" style="display: flex; justify-content: flex-end">
        <div class="col-md-6">
          <div class="input-group" style="width: 100%">
            <div class="input-group-prepend" style="height: 43px">
              <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                {{
                  options.searchFilter.find(
                    (x) => x.value == filter.search_by
                  ).text
                }}&nbsp;<i class="fas fa-caret-down"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" v-for="opt in options.searchFilter" @click="filter.search_by = opt.value">{{
                  opt.text }}</a>
              </div>
            </div>
            <input v-model="filter.search" type="text" class="form-control"
              aria-label="Text input with dropdown button" style="height: 43px" :placeholder="'Type ' +
                options.searchFilter.find((x) => x.value == filter.search_by)
                  .text
                " />
          </div>
        </div>
        <div class="col-md-2">
          <MultiSelect v-model="filter.status" :options="options.status"  label="text"
  track-by="value" placeholder="Choose Status" :select-label="''"></MultiSelect>
        </div>
      </div>
    </div>

    <div class="bg-white shadow box-content mt-4">
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>
        
        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>QR Code</th>
                <th>Serial</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index">
                <td>{{ row.qrcode || 'N/A' }}</td>
                <td>{{ row.serial_number || 'N/A' }}</td>
                <td :style="getStatusStyle(row.status)">{{ row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase() || 'N/A' }}</td>
                <td class="date">{{ formatDate(row.created_at) }}</td>
              </tr>
              <tr v-if="!tableLoading && tableData.length === 0">
                <td colspan="4" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="view-items-per-page" style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select 
                id="view-items-per-page"
                v-model="limitPerPage" 
                @change="onLimitChange"
                class="form-control form-control-sm"
                style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px;">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing {{ (currentPage - 1) * limitPerPage + 1 }}-{{ currentPage * limitPerPage < total ? currentPage * limitPerPage : total }} of {{ total > 0 ? total : '?' }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }" @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= maxPage && !hasMoreData }" @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Start -->
    <qr-code-detail v-if="modal.detail" :id="modal.detailId" @closeModal="modal.detail = false"></qr-code-detail>
    <!-- Modal End -->
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import qrCodeDetail from "./children/qrCodeDetailModal";

export default {
  metaInfo: {
    title: "Report QR Code",
  },
  data() {
    return {
      modal: {
        detail: false,
        detailId: null,
      },
      options: {
        searchFilter: [
          { text: "QR Code", value: "qrcode" },
          { text: "Serial Number", value: "serial" },
        ],
        status: [
            { text: "Active", value: "ACTIVE" },
            { text: "Inactive", value: "INACTIVE" },
            { text: "Deactivated", value: "DEACTIVATED" },
          ], 
      },
      filter: {
        search: null,
        search_by: "qrcode",
        status: null,
      },
      // Table data
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      // Debounce timer
      fetchDataTimer: null,
    };
  },
  components: {
    qrCodeDetail,
  },
  computed: {
    hasMoreData() {
      // If we got a full page of data, there's likely more
      return this.tableData.length === this.limitPerPage;
    },
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  watch: {
    "filter.search": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1; // Reset to first page
        this.fetchData();
      }
    },
    "filter.status": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1; // Reset to first page
        this.fetchData();
      }
    },
    "filter.search_by": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1; // Reset to first page
        this.fetchData();
      }
    },
  },
  methods: {
    openDetail(id) {
      this.modal.detailId = id.replaceAll('"', '');
      this.modal.detail = true;
    },
    async fetchData() {
      // Clear existing timer to debounce rapid calls
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 300); // 300ms debounce
    },
    async performFetchData() {
      this.tableLoading = true;
      
      try {
        // Build filter object
        let queryParams = {
          pagination: true,
          limit: this.limitPerPage,
          page: this.currentPage,
          order: "DESC",
          by: "created_at",
        };

        // Add search filter
        if (this.filter.search && this.filter.search.trim()) {
          queryParams.search_by = this.filter.search_by;
          queryParams.search = this.filter.search.trim();
        }

        // Add status filter
      if (this.filter.status) {
          const s = this.filter.status;
          queryParams.status = (s.value ? s.value : s).toUpperCase();
        }

        const url = `/api/reports/qrcode?${qs.stringify(queryParams, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`;

        const resp = await this.$http.get(url);
        
        console.log('API Response:', resp.data);
        
        const rawData = resp.data.data || [];
        
        // Check for pagination meta in various possible locations
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};
        
        console.log('Pagination Meta:', meta);
        
        // Process data
        this.tableData = rawData.map((item) => ({
          ...item,
        }));

        // Handle pagination metadata - check multiple possible field names
        const currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage || 1;
        let total = meta.total || meta.totalItems || meta.total_count || meta.totalRecords || meta.count || 0;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;
        
        console.log('Parsed pagination:', { currentPage, total, lastPage, dataLength: this.tableData.length, limitPerPage: this.limitPerPage });
        
        // If total is 0 but we have data, we need to estimate
        // If we got a full page of data, there might be more pages
        if (total === 0) {
          if (this.tableData.length === this.limitPerPage) {
            // We got a full page, so there's likely more data
            // Set total to at least current page * limit, but we'll calculate lastPage differently
            total = this.currentPage * this.limitPerPage;
            // We'll calculate lastPage based on whether we can go to next page
            lastPage = this.currentPage + 1; // At least one more page exists
          } else if (this.tableData.length > 0) {
            // We got partial data, so this is likely the last page
            total = (this.currentPage - 1) * this.limitPerPage + this.tableData.length;
            lastPage = this.currentPage;
          } else {
            // No data
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          // We have total, calculate lastPage if not provided
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.limitPerPage);
          }
        }
        
        // Ensure lastPage is at least 1
        lastPage = Math.max(1, lastPage);
        
        // If we got a full page and we're on the last calculated page, there might be more
        if (this.tableData.length === this.limitPerPage && this.currentPage >= lastPage) {
          lastPage = this.currentPage + 1;
        }

        console.log('Final pagination state:', { currentPage, total, lastPage });

        // Update pagination state
        this.$set(this, 'currentPage', Number.parseInt(currentPage));
        this.$set(this, 'maxPage', Number.parseInt(lastPage));
        this.$set(this, 'total', Number.parseInt(total));
      } catch (err) {
        console.log('Error fetching QR code data:', err);
        this.$set(this, 'tableData', []);
        this.$set(this, 'currentPage', 1);
        this.$set(this, 'maxPage', 1);
        this.$set(this, 'total', 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.$set(this, 'currentPage', 1);
      this.fetchData();
    },
    changePage(opt) {
      if (this.tableLoading) {
        return;
      }
      
      let newPage = this.currentPage;
      
      if (opt === 'prev') {
        newPage = Math.max(1, this.currentPage - 1);
      } else if (opt === 'next') {
        // Allow going to next page if we have more data or if we're not at maxPage
        if (this.hasMoreData || this.currentPage < this.maxPage) {
          newPage = this.currentPage + 1;
        } else {
          return; // Can't go to next page
        }
      }
      
      if (newPage !== this.currentPage && newPage >= 1) {
        this.$set(this, 'currentPage', newPage);
        this.fetchData();
      }
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },
    getStatusStyle(status) {
      const styles = {
        ACTIVE: "color:#34CE4C; font-weight:bold",
        INACTIVE: "color:orange; font-weight:bold",
        DEACTIVATED: "color:red; font-weight:bold",
      };
      return styles[status] || "";
    },
  },
};
</script>

<style scoped>
.date{
  width: 200px
}

.box-content {
  padding: 20px;
  border-radius: 10px;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4B4B4B;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9D9D9D !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>